import React from "react";

import "./ListPage.css";

export const ListPage: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="list-page">{children}</div>;
